export default class DapAttenteGridController {
	/* @ngInject */
	constructor(
		$scope,
		$state,
		$stateParams,
		$translate,
		ModalService,
		PaginationService,
		DAPsService,
		notification,
		$uibModal,
		$transitions,
		DomainesService,
		moment
	) {
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.$translate = $translate;
		this.ModalService = ModalService;
		this.PaginationService = PaginationService;
		this.DAPsService = DAPsService;
		this.DomainesService = DomainesService;
		this.notification = notification;
		this.$uibModal = $uibModal;
		this.$transitions = $transitions;
		this.daps = [];
		this.isDomainPortailActif = false;
		this.isDomainPortailDapActif = false;
		this.noDapMessage = 'DAPS.ATTENTE.NO_DAP';
		this.moment = moment;
	}

	async $onInit() {
		this.isDomainPortailActif = await this.DomainesService.isDomainActif('Portail');
		this.isDomainPortailDapActif = await this.DomainesService.isDomainActif('PortailDAP');
		if (!this.isDomainPortailActif && !this.isDomainPortailDapActif) this.noDapMessage = 'DAPS.ATTENTE.NO_DOMAIN_AT_ALL';
		else if (this.isDomainPortailActif && !this.isDomainPortailDapActif)
			this.noDapMessage = 'DAPS.ATTENTE.NO_PORTAIL_DAP_DOMAIN_WITH_PORTAIL_DOMAIN';

		// DEBUG - Uncomment to bypass domain verification ;)
		// console.log(this.isDomainPortailActif, this.isDomainPortailDapActif, this.noDapMessage);
		// this.daps = await this.DAPsService.GetDapAttenteListByDemandeur();
		// this.isDomainPortailActif = true;
		// this.isDomainPortailDapActif = true;

		if (this.isDomainPortailActif && this.isDomainPortailDapActif) this.daps = await this.DAPsService.GetDapAttenteListByDemandeur();

		if (this.daps.length > 0) {
			this.daps.forEach((dap) => {
				if (dap.dateDebut) {
					dap.dateDebut = this.moment(dap.dateDebut, 'DD/MM/YYYY HH:mm').toDate();
				}
				if (dap.dateFin) {
					dap.dateFin = this.moment(dap.dateFin, 'DD/MM/YYYY HH:mm').toDate();
				}
			});
		}
	}

	async selectDAP(dap) {
		this.DAPsService.currentDAPAttente = dap;
		this.$state.go('daps.attente', { id: dap.id });
	}
}
